import { Check, Clock, CalendarDays, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const experiences = [
  "Live patient consultations",
  "Smile makeover treatment planning",
  "Chairside observation",
  "Clinical photography workflow",
  "Communication with patients",
  "Practice management insights",
  "Case discussions",
  "Aesthetic dentistry protocols",
  "Practice on real clients",
];

export const Mentorship = () => (
  <section id="mentorship" className="py-16 lg:py-24 px-4 sm:px-6 lg:px-10 bg-[#FAFAF8]" data-testid="mentorship-section">
    <div className="max-w-7xl mx-auto bg-[#0E0E0E] rounded-3xl p-8 sm:p-12 lg:p-16 text-white">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
        <div>
          <Reveal>
            <span className="font-heading text-xs sm:text-sm font-bold tracking-[0.25em] uppercase text-[#C6A45C]">The Internship Program</span>
            <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight mt-5 leading-[1.1]">
              Learn Aesthetic Dentistry in a <em className="font-bold text-[#E7CE96]">Real Clinical Environment</em>.
            </h2>
            <p className="mt-6 font-heading font-semibold text-lg text-[#E7CE96]">Experience what textbooks can't teach.</p>
            <p className="mt-4 text-base lg:text-lg text-white/75 leading-relaxed">
              Our Internship Program offers dentists the opportunity to observe, assist and learn
              inside a high-volume aesthetic dental practice where premium smile makeovers are
              performed every day.
            </p>
            <p className="mt-4 text-base lg:text-lg text-white/75 leading-relaxed">
              Gain exposure to patient consultations, treatment planning, clinical workflows,
              communication, photography and complete smile makeover execution while understanding
              how a modern aesthetic practice functions. This immersive experience bridges the gap
              between theory and real-world practice.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="mt-8 flex flex-wrap items-center gap-4">
            <span className="inline-flex items-center gap-2 font-heading text-sm font-bold text-[#E7CE96] bg-white/[0.07] rounded-lg px-4 py-2.5">
              <Clock size={15} /> 3 Months Immersive
            </span>
            <span className="inline-flex items-center gap-2 font-heading text-sm font-bold text-[#E7CE96] bg-white/[0.07] rounded-lg px-4 py-2.5" data-testid="mentorship-dates">
              <CalendarDays size={15} /> Dates: To Be Announced
            </span>
          </Reveal>
        </div>

        <div className="flex flex-col gap-6">
          <Reveal delay={0.1}>
            <div className="bg-white/[0.06] rounded-2xl p-8 lg:p-9" data-testid="mentorship-experience-list">
              <h3 className="font-heading font-bold text-xl text-white">You'll Experience</h3>
              <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-3.5">
                {experiences.map((item) => (
                  <div key={item} className="flex items-start gap-3">
                    <span className="mt-0.5 shrink-0 w-5 h-5 rounded-full bg-[#C6A45C] flex items-center justify-center">
                      <Check size={12} className="text-[#0E0E0E]" />
                    </span>
                    <p className="text-sm text-white/85">{item}</p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <div className="border border-[#C6A45C]/40 rounded-2xl p-7 lg:p-8">
              <h3 className="font-heading font-bold text-base text-[#E7CE96] tracking-[0.1em] uppercase">Ideal For</h3>
              <p className="mt-3 text-white/80 leading-relaxed">
                Dentists seeking real clinical exposure before independently performing aesthetic cases.
              </p>
              <a
                href={`https://wa.me/919321967864?text=${encodeURIComponent("Hi Dr. Kshama, I'm interested in the Internship Program.")}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="mentorship-enquire-btn"
                className="mt-6 inline-flex items-center gap-2 font-heading font-bold text-sm bg-[#C6A45C] text-[#0E0E0E] px-7 py-3.5 rounded-xl hover:bg-[#A88743] transition-colors duration-300"
              >
                Enquire About Internship <ArrowUpRight size={15} />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
